import { graphql } from 'relay-runtime';
export const composerEcommerceSettingsQuery = graphql`
    query composerQueriesEcommerceSettingsQuery {
        ecommerceSettings {
            ecommerceID
            ecommerceName
            productsApi
            remoteUrl
            currencyGlobalID
        }
        currencies {
            id
            name
        }
    }
`;

export const composerMerchantOptionsQuery = graphql`
    query composerQueriesMerchantProductOptionsQuery($sku: String!, $salesChannelId: ID!) {
        merchantProductOptions(sku: $sku, salesChannelID: $salesChannelId, environment: COMPOSER) {
            optionID
            label
            values {
                valueID
                label
            }
            isGlobal
            metadata {
                key
                value
            }
        }
    }
`;

export const composerCheckAiLimitQuery = graphql`
    query composerQueriesCheckAiLimitQuery {
        checkAILimited
    }
`;

export const composerGenerateAiAttributes = graphql`
    query composerQueriesGenerateAiAttributesQuery($input: AiGenerationInput!) {
        generatedAIAttributes(input: $input) {
            attributes {
                an
                o {
                    a {
                        t
                        m
                        mat
                    }
                    on
                }
            }
        }
    }
`;

export const composerListTemplatesQuery = graphql`
    query composerQueriesListTemplatesQuery($productId: Long!) {
        designTemplates(productId: $productId) {
            id
            name
            design {
                id
                designID
                currentModificationID
                compoundKey
                docID
                modelID
                modelName
                modelCode
                pricingModelID
                modelPriceDeltaPerc
                modelPriceDeltaValue
                modelPrice
                modelTextBasePrice
                modelImageBasePrice
                printTypeID
                name
                description
                isTemplate
                isLibrary
                templateDesignID
                customerID
                visitorID
                salesChannelID
                compositionID
                compositionDocID
                customerCode
                visitorCode
                finalPrice
                interfaceID
                marketPlaceOrderID
                tempPreviewImageUrl
                tempPreviewImageData
                canAddText
                canAddImage
                canAddShape
                canMaskImages
                maxNrTexts
                maxNrImages
                maxNrShapes
                filterCode
                canChangeSvgColors
                uploadRestrictions {
                    isUserImageAllowed
                    isJpgAllowed
                    isPngAllowed
                    isSvgAllowed
                    isPdfAllowed
                    isPdfWithRasterAllowed
                    isEpsAllowed
                    isAiAllowed
                    isFacebookAllowed
                    isInstagramAllowed
                    resizeLargePdf
                }
                disableSellerImages
                hasSyncEnabled
                tags
                isDraft
                isDeleted
                templateCode
                adaptItemsToVariants
                parentTemplateId
                pdSettings
                createdOn
                modifiedOn
                createdBy
                modifiedBy
                designItems {
                    itemID
                    itemGuid
                    index
                    name
                    json
                    svg
                    imageID
                    imageType
                    imageFormat
                    imageWidth
                    imageHeight
                    imageDpiX
                    imageDpiY
                    imageIsMulticolor
                    imagePreferredWidth
                    imagePreferredHeight
                    imageFileSize
                    imageSellerID
                    imageCustomerID
                    imageCustomerCode
                    imageVisitorID
                    imageVisitorCode
                    imagePrice
                    applyImagePriceForQuantity
                    providerImageID
                    itemColors
                    syncGuid
                    overridePreview
                    defaultLCID
                    tag
                    designItemTagType
                    colorMappings {
                        src
                        dest
                    }
                    areas {
                        id
                        modelID
                        colorID
                        sideID
                        areaID
                    }
                    colors {
                        key
                        imageID
                        colorID
                        colorCode
                    }
                    constraints {
                        itemID
                        canMove
                        canRotate
                        canResize
                        canDelete
                        canEdit
                        keepNrChars
                        minNrChars
                        maxNrChars
                        paddingTypeID
                        paddingString
                        canChangeFontFamily
                        canChangeFontSize
                        canChangeFontColor
                        canChangeFontWeight
                        canChangeFontItalic
                        canChangeTextPathMode
                        canChangeJustification
                        canTransform
                        canChangeSvgColors
                        isAlwaysOnTop
                        isAlwaysOnBottom
                        isPrintable
                        keepInPreview
                        mandatoryToEdit
                        canSyncContent
                        canSyncAlignment
                        canSyncFontFamily
                        canSyncFontStyle
                        canSyncFontColor
                        canSyncCurved
                        canSyncTransforms
                        canResizeTextBox
                        canChangeTextBoxMode
                        toUppercase
                        canAddMask
                        canReplaceMask
                        canEditMask
                        canDeleteMask
                        canEditMaskedImage
                        canChangeMaskStrokeColor
                        canChangeMaskStrokeWidth
                        canFillShape
                        canReplaceShapeFilling
                        canEditShapeFilling
                        canDeleteShapeFilling
                        canEditFilledShape
                        canChangeShapeStrokeColor
                        canChangeShapeStrokeWidth
                        canChangeShapeFillColor
                        canChangeLetterSpacing
                        minLetterSpacing
                        maxLetterSpacing
                        canChangeLineSpacing
                        minLineSpacing
                        maxLineSpacing
                        canChangeAdaptText
                        canWrapTextOnAdaptText
                        minFontSize
                        maxFontSize
                        canChangeVerticalAlignment
                        canChangeShadowColor
                        canChangeShadowBlur
                        canChangeShadowDistance
                        canChangeShadowAngle
                        minShadowBlur
                        maxShadowBlur
                        minShadowDistance
                        maxShadowDistance
                        minShadowAngle
                        maxShadowAngle
                        canChangeTextStrokeColor
                        canChangeTextStrokeWidth
                        minTextStrokeWidth
                        maxTextStrokeWidth
                        canStretch
                    }
                    textArt {
                        itemID
                        text
                        fontFamilyID
                        fontFaceID
                        textArtTypeID
                        config {
                            angleValue
                            curveValue
                            intensT
                            intensB
                            isTriangle
                            isBridge
                            isTop
                            isBottom
                            isMiddle
                        }
                    }
                    shape {
                        itemID
                        shapeID
                        isMask
                    }
                    patternSettings {
                        offsetX
                        offsetY
                        spacingX
                        spacingY
                        bounds
                        repeatX
                        repeatY
                        presetID
                        flipX
                        flipY
                        offsetType
                    }
                    fillGradientSettings {
                        gradientStops
                        gradientColors
                        radial
                        rotation
                        radius
                        centerX
                        centerY
                    }
                    fillImageSettings {
                        imageID
                        topPosition
                        leftPosition
                        rotation
                        syncRatio
                        scaling
                        scalingX
                        scalingY
                        horizontalFlip
                        verticalFlip
                    }
                }
                sides {
                    modelID
                    colorID
                    sideID
                    fillColor
                    canAddText
                    canAddImage
                    canAddShape
                    canMaskImages
                    maxNrTexts
                    maxNrImages
                    maxNrShapes
                    canChangeSvgColors
                    disableSellerImages
                }
                areas {
                    modelID
                    colorID
                    sideID
                    areaID
                    printTypeID
                }
                areasGrids {
                    modelID
                    colorID
                    sideID
                    areaID
                    gridID
                }
                canvasRotation {
                    sideID
                    degrees
                }
                colors {
                    colorID
                    name
                    isDefault
                }
                elementsDescs {
                    id
                    elements {
                        tag
                        text {
                            content
                            strokeColor
                            strokeWidth
                            fillColor
                            fontFamily
                            fontSize
                            fontWeight
                            fontStyle
                            fontStretch
                            justification
                            adaptText
                            letterSpacing
                            lineSpacing
                            verticalAlignment
                            shadowColor
                            shadowBlur
                            shadowDistance
                            shadowAngle
                        }
                        textArt {
                            content
                        }
                        image {
                            imageID
                        }
                        shape {
                            shapeID
                        }
                    }
                }
                sidesPrintTypes {
                    modelID
                    colorID
                    sideID
                    printTypeID
                }
                options {
                    id
                    colorID
                    sideID
                    height
                    width
                    columns
                    rows
                }
            }
        }
    }
`;

export const composerFontQuery = graphql`
    query composerQueriesFontQuery {
        fontFamilies {
            fontFamilyID
            name
            imageUrl
        }
    }
`;

export const composerQueriesImagesMacroQueriesCategoriesFragment = graphql`
    fragment composerQueriesImagesMacroQueriesCategories_fragment on Query @refetchable(queryName: "composerQueriesImagesMacroQueriesCategoriesFragmentQuery") {
        imageMacroCategories(onlybackground: $onlybackground, isLibrary: $isLibrary) {
            id
            name
            hasImages
            isSystemwide
            numberOfProducts
            onlyForBackgrounds
            macroCategoryPosition
            referenceKey
            categories {
                id
                name
                hasImages
                isSystemwide
                numberOfProducts
                categoryPosition
                referenceKey
            }
        }
    }
`;

export const composerQueriesImagesGalleryImagesQueriesCategoriesFragment = graphql`
    fragment composerQueriesImagesGalleryImagesQueriesCategories_fragment on Query
    @refetchable(queryName: "composerQueriesImagesGalleryImagesQueriesCategoriesFragmentQuery") {
        imageMacroCategories(onlybackground: $onlybackground, isLibrary: $isLibrary) {
            id
            name
            hasImages
            isSystemwide
            numberOfProducts
            onlyForBackgrounds
            macroCategoryPosition
            categories {
                id
                name
                hasImages
                isSystemwide
                numberOfProducts
                categoryPosition
            }
        }
    }
`;

export const composerCategoriesQuery = graphql`
    query composerQueriesImagesCategoriesQuery($onlybackground: Boolean!, $isLibrary: Boolean!) {
        ...composerQueriesImagesMacroQueriesCategories_fragment
        ...composerQueriesImagesGalleryImagesQueriesCategories_fragment
    }
`;

export const composerCategorySelectionQuery = graphql`
    query composerQueriesImagesQueriesQuery(
        $count: Int!
        $cursor: String
        $search: String
        $categoryID: ID
        $isLibrary: Boolean
        $sellerID: Long
        $isBackground: Boolean!
    ) {
        images(
            first: $count
            after: $cursor
            search: $search
            categoryID: $categoryID
            isLibrary: $isLibrary
            sellerID: $sellerID
            isBackground: $isBackground
        ) {
            edges {
                node {
                    id
                    name
                    choiceUrl
                    previewUrl
                    preferredWidth
                    preferredHeight
                    categories {
                        categoryID
                        name
                    }
                    numberOfProducts
                    price
                    code
                    url
                    isImageEnabled
                    firstCategoryID
                    __typename
                }
                cursor
            }
            pageInfo {
                endCursor
                hasNextPage
            }
        }
    }
`;

export const composerExtensionFieldsQuery = graphql`
    query composerQueriesExtensionFieldsQuery {
        extensionFields {
            id
            fieldID
            name
            label
            formatString
            dataTypeID
            dataTypeName
            operationTypeID
            operationTypeName
        }
    }
`;

export const composerCreateDesignTemplateMutation = graphql`
    mutation composerQueriesCreateDesignTemplateMutation($design: DesignInput!) {
        createDesigntemplate(design: $design) {
            id
            docID
            designID
        }
    }
`;

export const composerUpdateDesignTemplateMutation = graphql`
    mutation composerQueriesUpdateDesignTemplateMutation($design: DesignInput!) {
        updateDesignTemplate(design: $design) {
            id
            name
        }
    }
`;
